import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { isMobile, aspectRatio as ar } from "../../../../../common/parameters";
import getChordName from "../../../../../common/helpers/getChordName";
import { IBar, IPitch } from "../../../../../common/types";

import Icon from "../../../../icon";

import Score from "../../../Score/score-display";

import Wrapper from "../../Wrapper";

import getBirdsPath from "../Common/getBirdsPath";
import MessageDisplay from "../Common/MessageDisplay";
import NotEdited from "../Common/NotEdited";
import play, { resetPlay } from "../Common/play";
import setUp from "../Common/setupNotation";
import { failedInput } from "../Common/submitNotation";
import { selectNote } from "../Common/selectNoteNotation";
import getScale from "../Common/getScale";
import getScore from "../Common/getScore";
import { INotationThis } from "../Common/interfaces";

import { SubmitButton, PlayBtn, Label, TopRight, DeleteButton } from "../common-style";

import Chords3Ladder from "./Chords3Ladder";
import { ScoreWrapper, SolfaLadderWrapper, Asset1Wrapper, Asset2Wrapper, EasterBackground, ChristmasBackground } from "./styles";
import messages from "./messages";
import { IProps, IState } from "./interfaces";

class Chords3 extends Component<IProps, IState> {
    static defaultProps = {
        handlePlayCount: () => {},
        handleFailCount: () => {},
    };
    play = play.bind(this as unknown as INotationThis);
    setUp = setUp.bind(this as unknown as INotationThis);
    failedInput = failedInput.bind(this as unknown as INotationThis);
    selectNote = selectNote.bind(this as unknown as INotationThis);
    frame?: HTMLDivElement;
    pauseOffset?: number;
    firstPitch?: {
        bar: number,
        note: number,
    }
    constructor(props: IProps) {
        super(props);
        this.state = {
            submitable: false,
            submited: false,
            playing: false,
            completed: false,
            currentNote: null,
            notes: [],
            incorrectNotes: [],
            playingNote: [],
            activeVoice: 0,
            failedNote: false,
            playable: false,
            solfaNameTypes: [],
            doPos: {
                value: 0,
                alt: 0,
            }
        };
        if (props.setReset) {
            props.setReset(this.resetTask);
        }
        if (props.saveState) {
            props.saveState(this.saveState);
        }
        if (props.restoreState) {
            props.restoreState(this.restoreState);
        }
        if (props.showSolution) {
            props.showSolution(this.showSolution);
        }
    }
    resetTask = () => {
        this.setUp();

        this.setState({
            submitable: false,
            submited: false,
            completed: false,
            incorrectNotes: [],
            activeVoice: 0,
        });
    };
    saveState = () => {
        return {
            currentNote: this.state.currentNote,
            submited: this.state.submited,
            taskScore: this.state.taskScore,
            incorrectNotes: this.state.incorrectNotes,
            submitable: this.state.submitable,
            completed: this.state.completed,
            activeVoice: this.state.activeVoice,
        };
    };
    restoreState = (state: IState) => {
        this.setState({
            currentNote: state.currentNote,
            submited: state.submited,
            taskScore: state.taskScore,
            incorrectNotes: state.incorrectNotes,
            submitable: state.submitable,
            completed: state.completed,
            activeVoice: state.activeVoice,
        });
    };
    showSolution = () => {
        this.setState({
            taskScore: getScore(this.props.plan, this.props.task),
            completed: true,
            submited: true,
            currentNote: null,
            activeVoice: 0,
        });
    };
    componentDidMount() {
        this.setUp();
    }

    componentWillUnmount() {
        window.removeEventListener("blur", this.blur);
        if (this.state.playing) {
            this.play();
        }
    }

    blur = () => {
        this.play();
    };

    handleInput = (chord: string) => {
        let { taskScore, activeVoice } = this.state;
        const currentNote = this.state.currentNote!;
        let bar = (taskScore!["bars" + (activeVoice || "")] as IBar[])[currentNote.bar];
        if (!bar) return;
        let note = bar.notes[currentNote.note];
        if (!note) return;

        note.chord = chord;
        let lastNote;
        do {
            lastNote = { ...currentNote };
            currentNote.note++;
            if (bar.notes.length === currentNote.note) {
                currentNote.bar++;
                bar = taskScore!["bars" + (activeVoice || "")][currentNote.bar];
                currentNote.note = 0;
            }
        } while (
            (bar && bar.notes.length && bar.notes[currentNote.note].r) ||
            taskScore!["bars" + (activeVoice || "")][lastNote.bar].notes[lastNote.note].tie
        );

        this.setState({ taskScore: { ...taskScore! }, currentNote }, this.checkReady);
    };

    checkReady = () => {
        let { taskScore } = this.state;
        let submitable = true;
        for (let bar of taskScore!.bars) {
            if (!bar || bar.notes.length === 0) continue;
            if (!bar.notes[0].chord) {
                submitable = false;
            }
        }
        this.setState({ submitable });
    };

    submit = () => {
        let { taskScore } = this.state;
        const incorrectNotes: number[][] = [[], [], [], [], [], []];
        let totalNoteIndex = 0;
        let completed = true;
        for (let bar of taskScore!.bars) {
            if (!bar || bar.notes.length === 0) continue;
            const note = bar.notes[0];
            const p = note.p;
            const chordType = getChordName(p as IPitch[]);
            if (chordType !== note.chord) {
                incorrectNotes[0].push(totalNoteIndex);
                completed = false;
            }
            totalNoteIndex++;
        }

        if (completed) {
            if (this.props.completed) {
                this.props.completed(this.props.task.type);
            }
        } else {
            this.props.handleFailCount!();
        }

        this.setState({ incorrectNotes, completed, submited: true });
    };

    deletePitch = () => {
        const { taskScore } = this.state;
        let { ...currentNote } = this.state.currentNote!;
        let lastNote = {
            ...currentNote,
        };
        let bar = taskScore?.bars?.[currentNote.bar];
        if (bar && bar.notes[currentNote.note]) {
            let note = bar.notes[currentNote.note];
            if (note.chord) {
                delete note.chord;
                this.setState({ taskScore, submitable: false });
                return;
            }
        }
        do {
            currentNote.note--;
            if (-1 === currentNote.note) {
                currentNote.bar--;
                bar = taskScore!.bars[currentNote.bar];
                if (!bar) {
                    currentNote = lastNote;
                    break;
                }
                currentNote.note = bar.notes.length - 1;
            }
        } while (bar && bar.notes.length && bar.notes[currentNote.note].r);
        if (bar) {
            delete bar.notes[currentNote.note].chord;
        }
        this.setState({
            currentNote,
            taskScore,
            submited: false,
            incorrectNotes: [],
            submitable: false,
        });
    };

    render() {
        const {
            incorrectNotes,
            submitable,
            submited,
            playable,
            currentNote,
            playing,
            completed,
            taskScore,
            activeVoice,
            failedNote,
            playingNote,
        } = this.state;
        const { task, isLow, isDemo, plan, handleHomeworkNext, isEaster, isChristmas } = this.props;
        const { data } = task;
        if (!data || !playable)
            return (
                <div>
                    <div>
                        <Wrapper>
                            <NotEdited />
                        </Wrapper>
                    </div>
                </div>
            );
        let scale = getScale(plan, task);
        return (
            <div>
                <Wrapper isDemo={isDemo}>
                    {isLow && (
                        <>
                            <Asset1Wrapper>
                                <img src={getBirdsPath("/chords3/asset-01.svg")} alt="decoration" />
                            </Asset1Wrapper>
                            <Asset2Wrapper>
                                <img src={getBirdsPath("/chords3/asset-02.svg")} alt="decoration" />
                            </Asset2Wrapper>
                        </>
                    )}
                    {isEaster && (
                        <EasterBackground />
                    )}
                    {isChristmas && (
                        <ChristmasBackground />
                    )}
                    <ScoreWrapper isLow={isLow} isEaster={isEaster || isChristmas}>
                        <Score
                            score={taskScore!}
                            chords3Task
                            showPitches
                            {...(!submited && { currentNote: currentNote! })}
                            selectNote={this.selectNote}
                            activeVoice={activeVoice}
                            playingNote={playingNote}
                            scale={scale * (isLow ? 0.5425 : (isEaster || isChristmas) ? (1076 / ar.width) : 1)}
                            incorrectNotes={incorrectNotes}
                            themeColor={data.color}
                            whiteBackground={isLow}
                            playing={playing}
                            hideNotes={data.hideNotes && !completed}
                            isEaster={isEaster || isChristmas}
                        />
                    </ScoreWrapper>
                    <SolfaLadderWrapper className={cn(completed && "Completed")} isLow={isLow}>
                        <Chords3Ladder
                            handleInput={this.handleInput}
                            score={taskScore!}
                        />
                    </SolfaLadderWrapper>
                    <PlayBtn
                        isEaster={isEaster}
                        className={cn("button", "button--play")}
                        resetPlay={this.pauseOffset && !playing ? resetPlay.bind(this as unknown as INotationThis) : undefined}
                        onClick={() => {
                            if (isMobile) return;
                            this.play();
                        }}
                        onTouchStart={() => {
                            if (isMobile) this.play();
                        }}
                        isLow={isLow}
                    >
                        {playing ? <Icon i="pause" /> : <Icon i="play" />}
                        <Label>
                            <FormattedMessage {...messages.play} />
                        </Label>
                    </PlayBtn>
                    <TopRight isLow={isLow}>
                        {!completed && (
                            <DeleteButton
                                isEaster={isEaster}
                                isLow={isLow}
                                style={{
                                    bottom: "auto",
                                    left: "auto",
                                    padding: 16,
                                    paddingBottom: 6,
                                    paddingTop: 6,
                                    width: "auto",
                                    fontWeight: 400,
                                }}
                                className={cn("button", "button--info")}
                                onClick={this.deletePitch}
                            >
                                <FormattedMessage {...messages.delete} />
                            </DeleteButton>
                        )}
                    </TopRight>
                    {submitable && !completed && !incorrectNotes.length && (
                        <SubmitButton
                            isEaster={isEaster}
                            isLow={isLow}
                            style={{
                                top: isLow ? 30 : 6,
                                bottom: "auto",
                                right: "auto",
                                left: 540,
                                paddingBottom: 5,
                                paddingTop: 5,
                            }}
                            className={cn("button")}
                            onClick={this.submit}
                        >
                            <FormattedMessage {...messages.submit} />
                        </SubmitButton>
                    )}
                    {completed && (
                        <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="completed" handleHomeworkNext={handleHomeworkNext} />
                    )}
                    {submited && !completed && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrect" />}
                    {failedNote && !completed && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrectNote" />}
                </Wrapper>
            </div>
        );
    }
}

export default Chords3;
